import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { getSidebarIcon } from "../utils/sidebarIcons";

export default function SidebarNavItem({
  label,
  count,
  active,
  disabled,
  icon,
  compact = false,
  overview = false,
  action = false,
  className = "",
  onClick,
}) {
  const [hasIconError, setHasIconError] = useState(false);
  const itemIcon = icon || getSidebarIcon(label);

  useEffect(() => {
    setHasIconError(false);
  }, [itemIcon, label]);

  const showImageIcon =
    itemIcon?.type === "image" && itemIcon?.src && !hasIconError;

  const content = (
    <>
      {!compact ? (
        <span className="new-sidebar-nav-item__icon" aria-hidden="true">
          {showImageIcon ? (
            <img
              src={itemIcon.src}
              alt=""
              className={`new-sidebar-nav-item__icon-image ${
                itemIcon?.name ? `is-${itemIcon.name}` : ""
              }`}
              onError={() => setHasIconError(true)}
            />
          ) : (
            <FontAwesomeIcon icon={itemIcon?.fallback || itemIcon?.icon} />
          )}
        </span>
      ) : null}
      <span className="new-sidebar-nav-item__label">{label}</span>
      <span className="new-sidebar-nav-item__meta">
        {count ? <span className="new-sidebar-count">{count}</span> : null}
        {disabled ? <FontAwesomeIcon icon={faLock} /> : null}
      </span>
    </>
  );

  if (disabled) {
    return (
      <div
        className={`new-sidebar-nav-item ${
          compact ? "is-child" : ""
        } ${
          overview ? "is-overview" : ""
        } ${
          action ? "is-action" : ""
        } ${
          className
        } is-disabled`}
        aria-disabled="true"
      >
        {content}
      </div>
    );
  }

  return (
    <button
      type="button"
      className={`new-sidebar-nav-item ${compact ? "is-child" : ""} ${
        overview ? "is-overview" : ""
      } ${
        action ? "is-action" : ""
      } ${
        active ? "is-active" : ""
      } ${
        className
      }`}
      onClick={onClick}
    >
      {content}
    </button>
  );
}
